import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectServiceDeskRoute: InvariantJiraRoute = {
	name: 'servicedesk-redirect',
	path: '/jira/servicedesk/projects/:projectKey',
	exact: true,
};
